module.exports = __webpack_public_path__ + "static/media/29EUNOG20.2ef416cb.jpg";